import { useAtom } from "jotai";

import { $cliToolsAnalyticsEffect } from "../../internal/analytics";

/**
 * Hook that mounts the product analytics effects.
 *
 * Call this once at the app level to activate CLI tool detection
 * and other product analytics events.
 */
export function useProductAnalytics() {
	useAtom($cliToolsAnalyticsEffect);
}
